import React from "react";

const RaagDetails = ({ raag }) => {
  if (!raag) return null;

  const formatKey = (key) => {
    const replacements = {
     // Name: "नाम - Nāma - Name:",
     // Thaat: "थाट - Thāṭ - Parent Scale:",
      Time: "Samaya",//"समय - Samaya - Time:",
      //Arohana: "आरोहण - Ārohaṇa - Ascending Scale:",
      //Avarohana: "अवरोहण - Avarohaṇa - Descending Scale:",
      //Vadi: "वादी - Vādī - Principal Note:",
      //Samavadi: "संवादी - Saṁvādī - Second Principal Note:",
      //Synonym: "समान नाम - Samāna Nāma - Synonym:",
      //Similar: "समान राग - Samāna Rāga - Similar Raags:",
      Mood: "Rasa",//"रस - Rasa - Mood:",
      //Season: "ऋतु - Ṛtu - Season:",
    };

    return replacements[key] || key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className="border rounded-lg shadow-md bg-white max-w-3xl mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-center text-gray-800 mt-6">{raag.name}</h2>
      <table className="w-full table-auto border border-gray-300 text-left">
        <tbody>
          {Object.entries(raag).map(([key, value]) => {

            return (
              <tr key={key} className="even:bg-gray-50">
                <td className="py-3 px-4 font-medium text-gray-700 border border-gray-300 w-1/3 align-top">
                  {formatKey(key)}
                </td>
                <td className="py-3 px-4 text-gray-900 border border-gray-300">
                  {Array.isArray(value) ? value.join(", ") : value}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RaagDetails;
